export default {"src":"/_next/static/media/share.9eb87649.svg","height":284,"width":284};